<nav>
	<ul>
		<!--<li><button (click)="expireToken()">Expire Token</button></li>-->
		<li><a (click)="newQuote()">New Life Quote</a></li>
		<li><a [routerLink]="['/quote', 'my-quotes']">My Life Quotes</a></li>
	</ul>
</nav>
<div class="container quote-container stripe-bg">
  <router-outlet></router-outlet>
</div>